/*
  Primal Viking · Early Access campaign prices
  Bridge between the Early Access LP sections (pv-ea-offers, pv-ea-bundle-card,
  pv-ea-product-grid) and the Froya Bundle Discounts "Eyr campaign engine"
  app embed. The cards render Loop's prices in Liquid; when a campaign phase
  is running, checkout charges the campaign's first-order price instead
  (automatic "Campaign pricing" discount, first order only), so the cards ask
  the engine for that price and re-render their derived numbers from it.

  Engine API used (Froya-bundle-discounts app/lib/storefront/prices.js):
    window.EyrCampaignPrices.modelFor(variantId, handle)
      -> { sub: { was, now, off } | null, otp: {...} | null } | null (dollars)
         null when no campaign runs / prices are off / no discount on it.
    "eyr:campaign" on document after every engine check (phase, QA link, cart).

  API:
    PVEaCampaign.watch(fn)   run fn now (if the engine is up) and on every
                             engine update; fn re-renders from scratch.
    PVEaCampaign.price(variantId, handle, kind)
                             -> Promise<cents | null>, kind 'sub' (default)
                             or 'otp'. null = keep the Liquid price.
    PVEaCampaign.money(cents, trimZeros)
                             "$69.99"; trimZeros turns "$25.00" into "$25".
*/
(function () {
  if (window.PVEaCampaign) return;

  var watchers = [];
  var timer = null;

  function runAll() {
    watchers.forEach(function (fn) {
      try {
        fn();
      } catch (e) {
        console.warn('[PV EA campaign]', e);
      }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(runAll, 60);
  }

  document.addEventListener('eyr:campaign', schedule);

  function watch(fn) {
    watchers.push(fn);
    if (window.EyrCampaignPrices) schedule();
  }

  function price(variantId, handle, kind) {
    var api = window.EyrCampaignPrices;
    if (!api || typeof api.modelFor !== 'function' || !variantId || !handle) {
      return Promise.resolve(null);
    }
    return Promise.resolve(api.modelFor(String(variantId), handle))
      .then(function (model) {
        var p = model && model[kind || 'sub'];
        return p && p.now > 0 ? Math.round(p.now * 100) : null;
      })
      .catch(function () {
        return null;
      });
  }

  var formatters = {};

  function money(cents, trimZeros) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var whole = trimZeros && cents % 100 === 0;
    var key = currency + (whole ? ':0' : ':2');
    if (!formatters[key]) {
      // The store's language, like the engine's own formatter.
      var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || undefined;
      formatters[key] = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      });
    }
    return formatters[key].format(cents / 100);
  }

  window.PVEaCampaign = { watch: watch, price: price, money: money };
})();
